import { ServiceBase } from "../ServiceBase";
import { IGradualIncreaseHelperFactoryService } from "./gradual-increase-helper-factory.service.interface";
import { GradualIncreaseHelper } from "../../../utils/gradual-increase-helper";
import { IGradualIncreaseHelperParams, IGradualIncreaseHelper } from "../../../utils/gradual-increase-helper.interface";

export class GradualIncreaseHelperFactoryService extends ServiceBase implements IGradualIncreaseHelperFactoryService {
    create(params: IGradualIncreaseHelperParams): IGradualIncreaseHelper {
        return new GradualIncreaseHelper(params);
    }
}

